import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface CryptoAddressBrand {
    readonly CryptoAddress: unique symbol;
}
export const CryptoAddress = brand(
    NonEmptyString,
    (n): n is Branded<NonEmptyString, CryptoAddressBrand> => true,
    'CryptoAddress'
);
export type CryptoAddress = TypeOf<typeof CryptoAddress>;
